export var get = function () {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    return ({
        domain: 'config',
        eventType: 'get',
        data: {
            keys: keys,
        },
    });
};
//# sourceMappingURL=config.js.map